import { render, staticRenderFns } from "./Bye.vue?vue&type=template&id=4d253fa0"
import script from "./Bye.vue?vue&type=script&lang=js"
export * from "./Bye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports